import styled from '@emotion/styled';
import HistoryIcon from '@mui/icons-material/History';
import LayersIcon from '@mui/icons-material/Layers';
import SubjectIcon from '@mui/icons-material/Subject';
import TocIcon from '@mui/icons-material/Toc';
import React from 'react';

import UserNavigationMenu from '~/client/components/settings/user-navigation-menu';
import { LeftNavMenu, LeftNavMenuItem } from '~c/components/base/left-nav';
import { dashboardRouteUtil, policyDetailsRoutesUtil } from '~c/routes';

interface Props {
  className?: string;
}

const PolicyDetailImpl: React.FC<Props> = ({ className }) => {
  const dashboard = dashboardRouteUtil.useHelper();
  const { matchRoute, navigateTo } = policyDetailsRoutesUtil.useHelper();

  return (
    <LeftNavMenu
      className={className}
      name={policyDetailsRoutesUtil.routePrefix}
      header={{
        showBackButton: true,
        onClick: () => dashboard.navigateTo('POLICY_LIBRARY'),
      }}
    >
      <LeftNavMenuItem
        icon={LayersIcon}
        selected={matchRoute('CONTROL_BUNDLES')}
        onClick={() => navigateTo('CONTROL_BUNDLES')}
      >
        Control bundles
      </LeftNavMenuItem>
      <LeftNavMenuItem
        icon={TocIcon}
        selected={matchRoute('POLICY_DETAILS')}
        onClick={() => navigateTo('POLICY_DETAILS')}
      >
        Referencing projects
      </LeftNavMenuItem>
      <LeftNavMenuItem
        icon={SubjectIcon}
        selected={matchRoute('EXCLUDED_PROJECT')}
        onClick={() => navigateTo('EXCLUDED_PROJECT')}
      >
        Non-referencing projects
      </LeftNavMenuItem>
      <LeftNavMenuItem
        icon={HistoryIcon}
        selected={matchRoute('PREVIOUS_VERSIONS')}
        onClick={() => navigateTo('PREVIOUS_VERSIONS')}
      >
        Previous Versions
      </LeftNavMenuItem>
      <UserNavigationMenu />
    </LeftNavMenu>
  );
};

const PolicyDetail = styled(PolicyDetailImpl)`
  .grow {
    flex-grow: 1;
  }
`;

export default PolicyDetail;
